import React from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features = [{
    name: 'IBS-specific peer-reviewed clinical trial',
    nerva: true,
    rifaximin: false,
    fodmap: false,
    apollo: false,
    pulsetto: false
  }, {
    name: '60-day money-back guarantee',
    nerva: true,
    rifaximin: false,
    fodmap: null,
    apollo: false,
    pulsetto: false
  }, {
    name: 'One-time cost under $500',
    nerva: true,
    rifaximin: '~$1,200/yr',
    fodmap: 'Ongoing',
    apollo: true,
    pulsetto: true,
    pulsettoText: '~$280'
  }, {
    name: 'Targets vagus nerve directly (real tcVNS)',
    nerva: true,
    rifaximin: false,
    fodmap: false,
    apollo: false,
    pulsetto: 'Partial'
  }, {
    name: 'Addresses root cause (vagal signal)',
    nerva: true,
    rifaximin: false,
    fodmap: false,
    apollo: false,
    pulsetto: false
  }, {
    name: 'No subscription / no hidden charges',
    nerva: true,
    rifaximin: null,
    fodmap: null,
    apollo: false,
    pulsetto: false
  }, {
    name: 'Drug-free, no side effects on gut',
    nerva: true,
    rifaximin: false,
    fodmap: true,
    apollo: true,
    pulsetto: true
  }, {
    name: '10 min/day session (no all-day wear)',
    nerva: true,
    rifaximin: null,
    fodmap: null,
    apollo: false,
    pulsetto: true
  }];
  const renderValue = (val: boolean | string | null, customText?: string) => {
    if (val === true) return <Check className="mx-auto text-sage" size={20} strokeWidth={3} data-id="element-118" />;
    if (val === false) return <X className="mx-auto text-[#A36B5D]/50" size={20} strokeWidth={2} data-id="element-119" />;
    if (val === null) return <span className="text-ink/30 text-sm" data-id="element-120">N/A</span>;
    if (typeof val === 'string' && val === 'Partial') return <span className="text-sm font-medium text-ink/60 italic" data-id="element-121">Partial</span>;
    return <span className="text-sm font-medium text-ink/70" data-id="element-122">
        {customText || val}
      </span>;
  };
  return <div className="my-16" data-id="element-123">
      <div className="overflow-x-auto pb-6 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-124">
        <div className="min-w-[800px] bg-white rounded-2xl shadow-sm border border-taupe/30 overflow-hidden" data-id="element-125">
          <table className="w-full text-left border-collapse" data-id="element-126">
            <thead data-id="element-127">
              <tr className="border-b border-taupe/30" data-id="element-128">
                <th className="p-4 sm:p-6 bg-white sticky left-0 z-10 w-1/3" data-id="element-129"></th>
                <th className="p-4 sm:p-6 bg-sage/10 text-center border-x border-sage/20 w-[14%]" data-id="element-130">
                  <span className="font-serif font-bold text-forest text-lg" data-id="element-131">
                    Nerva™
                  </span>
                </th>
                <th className="p-4 sm:p-6 text-center text-sm font-medium text-ink/60 w-[13%]" data-id="element-132">
                  Rifaximin
                </th>
                <th className="p-4 sm:p-6 text-center text-sm font-medium text-ink/60 w-[13%]" data-id="element-133">
                  Low-FODMAP
                </th>
                <th className="p-4 sm:p-6 text-center text-sm font-medium text-ink/60 w-[13%]" data-id="element-134">
                  Apollo / Sensate
                </th>
                <th className="p-4 sm:p-6 text-center text-sm font-medium text-ink/60 w-[14%]" data-id="element-135">
                  Pulsetto
                </th>
              </tr>
            </thead>
            <tbody data-id="element-136">
              {features.map((feature, idx) => <tr key={idx} className="border-b border-taupe/10 last:border-0 hover:bg-beige/20 transition-colors" data-id="element-137">
                  <td className="p-4 sm:p-6 text-sm font-medium text-ink/80 sticky left-0 bg-white/95 backdrop-blur-sm shadow-[4px_0_12px_rgba(0,0,0,0.02)] sm:shadow-none" data-id="element-138">
                    {feature.name}
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-sage/5 border-x border-sage/10" data-id="element-139">
                    {renderValue(feature.nerva)}
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-white" data-id="element-140">
                    {renderValue(feature.rifaximin)}
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-white" data-id="element-141">
                    {renderValue(feature.fodmap)}
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-white" data-id="element-142">
                    {renderValue(feature.apollo)}
                  </td>
                  <td className="p-4 sm:p-6 text-center bg-white" data-id="element-143">
                    {renderValue(feature.pulsetto, feature.pulsettoText)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}